import { useMemo } from 'react';
import success from '~/assets/icons/success.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CollectionImage } from '~/components/collections/CollectionImage';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { useInventoryCells } from '../../hooks';
import { setFinishScreenVisible, useLayoutDispatch } from '../../redux';
import {
	StyledBg,
	StyledBgCircle,
	StyledContainer,
	StyledContinueButton,
	StyledItem,
	StyledItemsContainer,
	StyledResultContainer,
} from './InventoryExchangeFinishScreen.styled';

const InventoryExchangeFinishScreen = () => {
	const dispatch = useLayoutDispatch();
	const otherPlayerInfo = useObservable(rage.inventory.getOtherPlayerInfo());
	const { toExchangeCells } = useInventoryCells();

	const items = useMemo(() => {
		return toExchangeCells
			.filter((cell) => !!cell.item)
			.map((cell) => {
				return {
					id: cell.item?.id,
					count: cell.item?.count,
					name: cell.item?.name,
				};
			});
	}, [toExchangeCells]);

	return (
		<StyledContainer>
			<StyledBg />
			<StyledBgCircle />
			<StyledResultContainer>
				<img src={success} width={30} height={30} />
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Обмен успешно завершен!
				</Text>
				<Text style={{ fontSize: 16, color: 'rgba(255, 255, 255, 0.5)' }}>
					При обмене с игроком{' '}
					<span style={{ color: '#ffffff' }}>{otherPlayerInfo?.nickname}</span>{' '}
					вы получили:
				</Text>
				<StyledItemsContainer>
					{items.map((item, index) => (
						<StyledItem key={index}>
							<CollectionImage
								collection="items"
								id={item.id ?? ''}
								size={50}
							/>
							<Text>
								{item.name}{' '}
								{item.count && item.count > 1 && `${item.count} шт.`}
							</Text>
						</StyledItem>
					))}
				</StyledItemsContainer>
				<StyledContinueButton
					onClick={() => {
						dispatch(setFinishScreenVisible(false));
						rage.inventory.closeExchange().catch(() => undefined);
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				>
					Продолжить
				</StyledContinueButton>
			</StyledResultContainer>
		</StyledContainer>
	);
};

export { InventoryExchangeFinishScreen };
